import { Eye, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import { getImpersonationData, exitImpersonation } from "@/utils/clientUtils";

export function ImpersonationBanner() {
  const impersonationData = getImpersonationData();
  
  if (!impersonationData) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-amber-500/95 backdrop-blur-sm text-amber-950 py-2 px-4">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Eye className="w-5 h-5" />
          <div>
            <span className="font-semibold">Admin View:</span>{" "}
            <span>Viewing as {impersonationData.clientName}</span>
            <span className="ml-2 text-amber-800 text-sm">
              — You are seeing exactly what this client sees
            </span>
          </div>
        </div>
        <Button
          variant="ghost"
          size="sm"
          className="text-amber-950 hover:bg-amber-600/50"
          onClick={exitImpersonation}
        >
          <LogOut className="w-4 h-4 mr-2" />
          Exit Admin View
        </Button>
      </div>
    </div>
  );
}
